import { render } from "./DashboardConvoySettings.vue?vue&type=template&id=1167b308"
import script from "./DashboardConvoySettings.vue?vue&type=script&lang=js"
export * from "./DashboardConvoySettings.vue?vue&type=script&lang=js"

import "./DashboardConvoySettings.vue?vue&type=style&index=0&id=1167b308&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__